import type { SxProps, Theme } from '@mui/material'

export const styles: Record<'wrapper' | 'documentsComplete', SxProps<Theme>> = {
  wrapper: {
    display: 'contents',
  },
  documentsComplete: {
    color: 'success.main',
    '.MuiBadge-badge': {
      backgroundColor: 'success.main',
    },
  },
}
